import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { API_AGENTS_AVAILABILITY } from 'core/constants/endpoints'

function getAgentsAvailability(state_acronym) {
  return fetchJSONHandleError({
    url: `${API_AGENTS_AVAILABILITY}/five9/agent-available?skill-name=U65 - ${state_acronym}`
  })
}

export default getAgentsAvailability
